var exports = {
  "kL": "xfd349460--fa37a0--container",
  "vu": "xfd349460--fa37a0--active",
  "DD": "xfd349460--fa37a0--title",
  "WD": "xfd349460--fa37a0--labels",
};

module.exports = exports;
